import config from 'config'
import { createLogic } from 'redux-logic'
import { fetchAction, getDateForRequest } from 'utils'

import {
  FETCH_DISTRICT_RESULTS,
  FETCH_DISTRICT_RESULTS_ERROR,
  FETCH_DISTRICT_RESULTS_SUCCESS,
  FETCH_REGION_RESULTS,
  FETCH_REGION_RESULTS_ERROR,
  FETCH_REGION_RESULTS_SUCCESS,
} from './constants'

const fetchDistrictResults = createLogic({
  type: FETCH_DISTRICT_RESULTS,
  latest: true,

  async process({ getState }, dispatch, done) {
    try {
      const state = getState()
      const { dateCurrent, dateCompared } = state.datePicker

      const response = await fetchAction(config.api.districtResults, {
        dateCurrent: getDateForRequest(dateCurrent),
        dateCompared: getDateForRequest(dateCompared),
      })

      dispatch({
        type: FETCH_DISTRICT_RESULTS_SUCCESS,
        payload: response.data,
      })
    } catch (error) {
      dispatch({
        type: FETCH_DISTRICT_RESULTS_ERROR,
      })
    }

    done()
  },
})

const fetchRegionResults = createLogic({
  type: FETCH_REGION_RESULTS,
  latest: true,

  async process({ getState }, dispatch, done) {
    try {
      const state = getState()
      const { dateCurrent, dateCompared } = state.datePicker

      const response = await fetchAction(config.api.regionResults, {
        dateCurrent: getDateForRequest(dateCurrent),
        dateCompared: getDateForRequest(dateCompared),
      })

      dispatch({
        type: FETCH_REGION_RESULTS_SUCCESS,
        payload: response.data,
      })
    } catch (error) {
      dispatch({
        type: FETCH_REGION_RESULTS_ERROR,
      })
    }

    done()
  },
})

export default [fetchDistrictResults, fetchRegionResults]
